module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper not-found"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "not-found__image",
    attrs: {
      "src": this.randomFailGif
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fdbad3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NotFound.vue
// module id = 262
// module chunks = 0